import { ChakraV3, QRCode } from '@piccolohealth/ui';
import React from 'react';
import { NavLink } from 'react-router-dom';

interface Props extends Omit<ChakraV3.IconButtonProps, 'aria-label'> {
  qrId: string;
}

export const ParticipantQRCode = (props: Props) => {
  const { qrId, ...rest } = props;
  const value = `${window.origin}/recording/qr/${qrId}`;

  return (
    <NavLink to={value}>
      <ChakraV3.IconButton
        variant='outline'
        aria-label='QR code'
        p={2}
        h={24}
        w={24}
        css={{ '& svg': { width: 'full', height: 'full' } }}
        {...rest}
      >
        <QRCode value={value} boxSize='full' />
      </ChakraV3.IconButton>
    </NavLink>
  );
};
